import { Star } from 'lucide-react'
import { CasinoGameCardList } from '@/components/casino/lobby/game-card/CasinoGameCardList'
import { CASINO_GAMES_PER_PAGE } from '@/config/casino'
import { useGetCasinoGamesQuery } from '@/store/api/casinoApi'

export function CasinoPopularContent() {
	const { data, isLoading, isError } = useGetCasinoGamesQuery({
		is_popular: true,
		page: 1,
		per_page: CASINO_GAMES_PER_PAGE,
	})

	return (
		<section className='flex flex-col gap-4'>
			<div className='flex items-center gap-3'>
				<Star className='h-7 w-7 text-subtle-foreground' />
				<h2 className='text-2xl font-semibold tracking-[-0.12px] text-foreground'>Popular</h2>
			</div>
			<CasinoGameCardList games={data?.data ?? []} isLoading={isLoading} isError={isError} layout='grid' emptyMessage='No popular games are available right now.' />
		</section>
	)
}
